import {
  // Circle,
  Document,
  Image,
  Page,
  // Path,
  pdf,
  // Svg,
  Text,
  View,
} from "@react-pdf/renderer";
import completeStatusIcon from "assets/images/completeStatus.png";
import incompleteStatusIcon from "assets/images/incompleteStatus.png";
import borLogo from "assets/logos/bor-logo.png";
import UVDLogo from "assets/logos/uvd-logo.png";
import { format } from "date-fns";
import { saveAs } from "file-saver";
import _ from "lodash";
import { FormattedMessage, IntlProvider } from "react-intl";
import { interruptionMsg } from "trans/definedMessages/interruptionMessages";
import { getUVDSerialNumber } from "utils/UVD/getUVDRobotSerialNumber";
import {
  DisinfectedPositionIcon,
  FailedPositionIcon,
  RemainingPositionIcon,
  SkippedPositionIcon,
} from "../../../assets/icons/PositionIcons";
import { Event } from "../../../gql/graphql";
import {
  EventType,
  EventTypeToMessageString,
} from "../../organisms/disinfectionReportWidgets/ReportTabs/LogsTab";
import { styles } from "./styles";

const getPositionText = (value: string) => {
  const stringArr = value.split("");

  if (stringArr.length > 60) {
    return value.slice(0, 60) + " ...";
  } else {
    return value;
  }
};

// const formatTimeToHHMM = (date: Date | string) => {
//   return new Date(date).toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: false,
//   });
// };

const getDocument = (reportData: any, mapSrc?: string | undefined) => (
  <Document>
    <IntlProvider locale="en">
      <Page style={styles.page} size="A4" wrap={true}>
        <View style={styles.headerContainer} fixed>
          <View style={styles.mainHeaderWrapper}>
            <Text style={styles.mainHeader}>Disinfection Report</Text>
            <Image src={UVDLogo} style={styles.headerLogo} />
          </View>
          <View style={styles.column}>
            <View style={styles.disinfectionStatus}>
              <Image
                src={
                  reportData.status === "complete"
                    ? completeStatusIcon
                    : incompleteStatusIcon
                }
                style={styles.disinfectionStatusLogo}
              />
              <View style={styles.disinfectionStatusWrapper}>
                <Text>Disinfection {reportData.status}</Text>
              </View>
            </View>
            <View style={styles.headerInfoContainer}>
              <View style={styles.leftHeaderInfoWrapper}>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>Room:</Text>{" "}
                  {reportData.room || "-"}
                </Text>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>Department:</Text>{" "}
                  {reportData.department || "-"}
                </Text>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>Robot name:</Text>{" "}
                  {reportData.robot?.robot?.serialNumber ||
                    getUVDSerialNumber(reportData.robotId)}
                </Text>
              </View>
              <View style={styles.rightHeaderInfoWrapper}>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>Date:</Text>{" "}
                  {format(new Date(reportData.end), "dd MMM yyyy")}
                </Text>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>
                    Report exported from timezone:
                  </Text>{" "}
                  {"UTC"}
                  {new Date().getTimezoneOffset() > 0 ? "-" : "+"}
                  {Math.abs(Math.floor(new Date().getTimezoneOffset() / 60))
                    .toString()
                    .padStart(2, "0")}
                  {":"}
                  {Math.abs(new Date().getTimezoneOffset() % 60)
                    .toString()
                    .padStart(2, "0")}
                </Text>
                <Text style={styles.detailListItem}>
                  <Text style={styles.boldText}>Disinfection ID:</Text>{" "}
                  {reportData.id}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {mapSrc && !reportData?.mapError ? (
          <View style={styles.mapImageContainer} fixed={false}>
            <Image src={mapSrc} style={styles.mapImage} />
            {/* <View style={styles.mapLegendWrapper}>
              <View style={styles.row}>
                <Text style={styles.mapLegendHeader}>
                  UV Irradiation exposure
                </Text>
              </View>
              <View style={styles.row}>
                <View style={styles.mapLegendColor100}></View>
                <Text style={styles.mapLegendText}>100</Text>
              </View>
              <View style={styles.row}>
                <View style={styles.mapLegendColor75}></View>
                <Text style={styles.mapLegendText}>75</Text>
              </View>
              <View style={styles.row}>
                <View style={styles.mapLegendColor50}></View>
                <Text style={styles.mapLegendText}>50</Text>
              </View>
              <View style={styles.row}>
                <View style={styles.mapLegendColor25}></View>
                <Text style={styles.mapLegendText}>25</Text>
              </View>
              <View style={styles.row}>
                <View style={styles.mapLegendColor0}></View>
                <Text style={styles.mapLegendText}>0 mJ/cm²</Text>
              </View>
            </View> */}
          </View>
        ) : (
          <View style={styles.emptyMapContainer} fixed={false}>
            <Text style={styles.emptyMapTextHeader}>
              {reportData?.mapError}
            </Text>
          </View>
        )}

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 20,
            marginTop: 10,
          }}
        >
          <View
            style={{
              display: "flex",
              flex: 1,
            }}
          >
            <Text style={styles.detailsTxt}>DETAILS</Text>
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.disinfectionType"
                    defaultMessage="Disinfection mode"
                  />
                </Text>
                <Text style={styles.listItemValue}>{reportData.type}</Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.started"
                    defaultMessage="Start time"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {format(new Date(reportData.start), "dd MMM yyyy - HH:mm")}
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.startedBy"
                    defaultMessage="Started by"
                  />
                </Text>
                <Text style={styles.listItemValue}>{reportData.startedBy}</Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.ended"
                    defaultMessage="Disinfection finished"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {format(new Date(reportData.end), "dd MMM yyyy - HH:mm")}
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.submittedBy"
                    defaultMessage="Finished by"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.submittedBy}
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.uvdLightDuration"
                    defaultMessage="UV-C light duration"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.uvcLightDurationInHMS}
                </Text>
              </View>
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.totalDuration"
                    defaultMessage="Total duration"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.taskDuration}
                </Text>
              </View>
            </View>
            {reportData.type === "Predefined" && !reportData?.mapError ? (
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.positionsDisinfected"
                    defaultMessage="Positions disinfected   "
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.positions?.completed.length}
                </Text>
              </View>
            ) : null}
            {reportData.type === "Predefined" && !reportData?.mapError ? (
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.positionsRemaining"
                    defaultMessage="Positions remaining"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.positions?.remaining.length}
                </Text>
              </View>
            ) : null}
            {reportData.type === "Predefined" && !reportData?.mapError ? (
              <View style={styles.listItem}>
                <Text style={styles.listItemHeader}>
                  <FormattedMessage
                    id="uvd.report.positionsFailed"
                    defaultMessage="Positions failed driving to point"
                  />
                </Text>
                <Text style={styles.listItemValue}>
                  {reportData.positions?.failed.length}
                </Text>
              </View>
            ) : null}
          </View>

          <View
            style={{
              display: "flex",
              flex: 1,
            }}
          >
            <Text style={styles.detailsTxt}>INTERRUPTIONS</Text>
            {reportData.interruptions?.map(
              (item: { label: string; value: number }) => {
                if (item.value === 0) return null;
                if (!interruptionMsg[item.label]) {
                  console.warn("Undefined interruption reason: ", item.label);
                  return null;
                }
                return (
                  <View key={item.label} style={styles.listItem}>
                    <Text style={styles.listItemHeader}>
                      <FormattedMessage {...interruptionMsg[item.label]} />
                    </Text>
                    <Text style={styles.listItemValue}>{item.value}</Text>
                  </View>
                );
              },
            )}
            {reportData.interruptions?.length === 0 ? (
              <View style={styles.listItemNoBorder}>
                <Text style={styles.listItemValue}>No interruptions</Text>
              </View>
            ) : null}
          </View>
        </View>

        {reportData.type === "Predefined" && !reportData?.mapError ? (
          <Text style={styles.detailsTxt} break>
            <FormattedMessage
              id="uvd.report.positions"
              defaultMessage="Positions"
            />
          </Text>
        ) : null}
        {reportData.type === "Predefined" &&
        !reportData?.mapError &&
        (reportData.positions.completed.length > 0 ||
          reportData.positions.failed.length > 0 ||
          reportData.positions.remaining.length > 0) ? (
          <View style={styles.positionWrapper}>
            {reportData.positions.completed.length > 0 ? (
              <Text style={styles.positionHeader}>
                <FormattedMessage
                  id="uvd.report.disinfected"
                  defaultMessage="Disinfected"
                />
              </Text>
            ) : null}
            {reportData.positions.completed.map((disinfectionPosition: any) => (
              <View
                wrap={false}
                key={disinfectionPosition.uuid}
                style={styles.positionListItem}
              >
                <View style={styles.positionIconContainer}>
                  <View style={styles.positionIconImage}>
                    <DisinfectedPositionIcon />
                  </View>
                  <Text style={styles.positionIconText}>
                    {disinfectionPosition.order}
                  </Text>
                </View>
                <Text style={styles.positionText}>
                  {getPositionText(disinfectionPosition.name || "")}
                </Text>
              </View>
            ))}
            {reportData.positions.failed.length > 0 ? (
              <Text style={styles.positionHeader}>
                <FormattedMessage
                  id="uvd.report.failed"
                  defaultMessage="Failed to disinfect"
                />
              </Text>
            ) : null}
            {reportData.positions.failed.map((disinfectionPosition: any) => (
              <View
                wrap={false}
                key={disinfectionPosition.uuid}
                style={styles.positionListItem}
              >
                <View style={styles.positionIconContainer}>
                  <View style={styles.positionIconImage}>
                    <FailedPositionIcon />
                  </View>
                  <Text style={styles.positionIconText}>
                    {disinfectionPosition.order}
                  </Text>
                </View>
                <Text style={styles.positionText}>
                  {getPositionText(disinfectionPosition.name || "")}
                </Text>
              </View>
            ))}
            {reportData.positions.remaining.length > 0 ? (
              <Text style={styles.positionHeader}>
                <FormattedMessage
                  id="uvd.report.remaining"
                  defaultMessage="Remaining"
                />
              </Text>
            ) : null}
            {reportData.positions.remaining.length > 0
              ? reportData.positions.remaining.map(
                  (disinfectionPosition: any) => (
                    <View
                      wrap={false}
                      key={disinfectionPosition.uuid}
                      style={styles.positionListItem}
                    >
                      <View style={styles.positionIconContainer}>
                        <View style={styles.positionIconImage}>
                          <RemainingPositionIcon />
                        </View>
                        <Text style={styles.remainingPositionIconText}>
                          {disinfectionPosition.order}
                        </Text>
                      </View>
                      <Text style={styles.positionText}>
                        {getPositionText(disinfectionPosition.name || "")}
                      </Text>
                    </View>
                  ),
                )
              : null}
            {reportData.positions.skipped.length > 0 ? (
              <Text style={styles.positionHeader}>
                <FormattedMessage
                  id="uvd.report.skipped"
                  defaultMessage="Skipped"
                />
              </Text>
            ) : null}
            {reportData.positions.skipped.map((disinfectionPosition: any) => (
              <View
                wrap={false}
                key={disinfectionPosition.uuid}
                style={styles.positionListItem}
              >
                <View style={styles.positionIconContainer}>
                  <View style={styles.positionIconImage}>
                    <SkippedPositionIcon />
                  </View>
                  <Text style={styles.positionIconText}>
                    {disinfectionPosition.order}
                  </Text>
                </View>
                <Text style={styles.positionText}>
                  {getPositionText(disinfectionPosition.name || "")}
                </Text>
              </View>
            ))}
          </View>
        ) : null}

        {/* //LSBRI -TODO: Logging will be a premium feature, enable this again once robots start providing Feature Flags */}
        {/* {reportData.events.length > 0 ? (
          <>
            <Text style={styles.detailsTxt} break>
              <FormattedMessage
                id="uvd.report.events"
                defaultMessage="Disinfection Log"
              />
            </Text>
            <View>
              {reportData.events.map((item: Event) => {
                const formattedTime = formatTimeToHHMM(item.time);
                const formattedCommentTime = item.commentTime
                  ? formatTimeToHHMM(item.commentTime)
                  : null;

                return (
                  <View key={item.id}>
                    <View style={styles.logItem}>
                      {(() => {
                        const scale = 0.5;
                        return (
                          <Svg
                            width={24 * scale}
                            height={24 * scale}
                            viewBox={`0 0 ${24 * scale} ${24 * scale}`}
                            style={{ marginRight: 10 }}
                          >
                            <Circle
                              cx={12 * scale}
                              cy={12 * scale}
                              r={10 * scale}
                              stroke="#000"
                              strokeWidth={1.5 * scale}
                              fill="none"
                            />
                            <Path
                              d={`M${8 * scale} ${12 * scale}l${3 * scale} ${3 * scale}l${6 * scale} -${6 * scale}`}
                              stroke="#000"
                              strokeWidth={1.5 * scale}
                              fill="none"
                            />
                          </Svg>
                        );
                      })()}
                      <Text style={styles.logTime}>{formattedTime}</Text>
                      <Text style={styles.logText}>
                        {EventTypeToMessageString[item.type as EventType] || ""}
                      </Text>
                      <Text style={styles.logUsername}>{item.username}</Text>
                    </View>
                    {item.commentMessage && (
                      <View style={styles.logItem}>
                        {(() => {
                          const scale = 0.5;
                          return (
                            <Svg
                              width={24 * scale}
                              height={24 * scale}
                              viewBox={`0 0 ${24 * scale} ${24 * scale}`}
                              style={{ marginRight: 10 }}
                            >
                              <Path
                                d={`M${19.125 * scale} ${3 * scale}H${4.875 * scale}C${4.17942 * scale} ${3.00198 * scale} ${3.51289 * scale} ${3.27918 * scale} ${3.02103 * scale} ${3.77103 * scale}C${2.52918 * scale} ${4.26289 * scale} ${2.25198 * scale} ${4.92942 * scale} ${2.25 * scale} ${5.625 * scale}V${14.625 * scale}C${2.25198 * scale} ${15.3206 * scale} ${2.52918 * scale} ${15.9871 * scale} ${3.02103 * scale} ${16.479 * scale}C${3.51289 * scale} ${16.9708 * scale} ${4.17942 * scale} ${17.248 * scale} ${4.875 * scale} ${17.25 * scale}H${6.75 * scale}V${21 * scale}L${11.1431 * scale} ${17.3372 * scale}C${11.2106 * scale} ${17.2808 * scale} ${11.2957 * scale} ${17.25 * scale} ${11.3836 * scale} ${17.25 * scale}H${19.125 * scale}C${19.8206 * scale} ${17.248 * scale} ${20.4871 * scale} ${16.9708 * scale} ${20.979 * scale} ${16.479 * scale}C${21.4708 * scale} ${15.9871 * scale} ${21.748 * scale} ${15.3206 * scale} ${21.75 * scale} ${14.625 * scale}V${5.625 * scale}C${21.748 * scale} ${4.92942 * scale} ${21.4708 * scale} ${4.26289 * scale} ${20.979 * scale} ${3.77103 * scale}C${20.4871 * scale} ${3.27918 * scale} ${19.8206 * scale} ${3.00198 * scale} ${19.125 * scale} ${3 * scale}V${3 * scale}Z`}
                                stroke="#000"
                                strokeWidth={1.5 * scale}
                                strokeLinejoin="round"
                                fill="none"
                              />
                            </Svg>
                          );
                        })()}
                        <Text style={styles.logTime}>
                          {formattedCommentTime}
                        </Text>
                        <Text style={styles.logText}>
                          "{item.commentMessage}"
                        </Text>
                        <Text style={styles.logUsername}>
                          {item.commentUsername}
                        </Text>
                      </View>
                    )}
                  </View>
                );
              })}
            </View>
          </>
        ) : null} */}

        <View fixed style={styles.footerWrapper}>
          <View style={styles.logoWrapper}>
            <View style={styles.logoLine}></View>
            <Image src={borLogo} style={styles.footerLogo} />
            <View style={styles.logoLine}></View>
          </View>
          <View style={styles.pageNumberWrapper}>
            <Text
              style={styles.pageNumber}
              render={({
                pageNumber,
                totalPages,
              }: {
                pageNumber: number;
                totalPages: number;
              }) => `${pageNumber} of ${totalPages}`}
            />
          </View>
        </View>
      </Page>
    </IntlProvider>
  </Document>
);

async function downloadPdf(reportData: any, onPDFReady: any) {
  const pdfInstance = pdf();
  pdfInstance.updateContainer(
    getDocument(reportData, (window as any).mapImageTracker),
  );
  const pdfBlob = await pdfInstance.toBlob();

  onPDFReady();

  const fileNameArr = [
    "UVDRobots_Disinfection",
    format(new Date(reportData.end), "_dd_MMM_yy_"),
    format(new Date(reportData.end), "HHmmss"),
    reportData.room === "" ? null : _.replace(reportData.room, ".", ""),
    reportData.department === ""
      ? null
      : _.replace(reportData.department, ".", ""),
    reportData.robot?.robot?.serialNumber ||
      getUVDSerialNumber(reportData.robotId),
  ];

  saveAs(
    URL.createObjectURL(pdfBlob),
    fileNameArr.filter((item) => !!item).join("_"),
  );
}

export { downloadPdf };
